// MODULAROOM product catalogue data (from official 2026 catalogue)
// All imagery = official Gemini renders. No stock photography.

const A = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_modularoom-design/artifacts/';

// ---------- Image aliases (official Gemini renders) ----------
const IMG = {
  cs25_1: `${A}2smyw1x1_Gemini%20CS25%201.png`,
  cs25_2: `${A}z45vnehk_Gemini%20CS25%202%281%29.png`,
  cs25_4: `${A}162bi3cc_Gemini%20CS25%204%281%29.png`,
  cs25_5: `${A}24vfdg1r_Gemini%20CS25%205%281%29.png`,
  cs25_6: `${A}27d07sh6_Gemini%20CS25%206%281%29.png`,
  cs31_hero: `${A}9zd8mcz0_6b5cca98-d5ef-4b59-a728-583b38b016b3.webp`,
  cs31_2: `${A}gwsgrw6d_Gemini%20CS31%202%281%29.webp`,
  cs31_3: `${A}t1cr7i5n_Gemini%20CS31%203%281%29.webp`,
  cs31_6: `${A}wa7q5k7k_Gemini%20CS31%206%281%29.webp`,
  cs31_7: `${A}id3goxi2_Gemini%20CS31%207%281%29.webp`,
  cs33_hero: `${A}qalnrf4h_d1498605-415f-432c-8527-70a729ccf41a.jpeg`,
  cs33_1: `${A}4o5p4zrf_Gemini%20CS33%201.png`,
  cs33_2: `${A}9u7la3o6_Gemini%20CS33%202%281%29.png`,
  cs33_3: `${A}iq7yl1ww_Gemini%20CS33%203%281%29.png`,
  cs33_4: `${A}jvfj602n_Gemini%20CS33%204%281%29.png`,
  cs33_5: `${A}gsn05nue_Gemini%20CS33%205%281%29.png`,
  cs33_8: `${A}po1oi3p2_Gemini%20CS33%208%281%29.png`,
  cs33_9: `${A}34lt1ndj_Gemini%20CS33%209.png`,
  cs37_1: `${A}pdn3tjcn_Gemini%20CS37%201%281%29.webp`,
  cs37_2: `${A}9aixbmel_Gemini%20CS37%202%281%29.webp`,
  cs37_3: `${A}5b5mzuzp_Gemini%20CS37%203.png`,
  cs37_4: `${A}bttnfcj9_Gemini%20CS37%204%281%29.png`,
  cs37_5: `${A}emc9ja8r_Gemini%20CS37%205%281%29.webp`,
  ss26_1: `${A}78ce6kbh_Gemini%20SS26%201.PNG`,
  ss26_2: `${A}aq7u1916_Gemini%20SS26%202%281%29.png`,
  ss26_3: `${A}fgjp879b_Gemini%20SS26%203%281%29.png`,
  ss26_4: `${A}q8y78dgm_Gemini%20SS26%204%281%29.webp`,
  ss26_5: `${A}p59t6dvk_Gemini%20SS26%205%281%29.png`,
  ss26_6:  `${A}kox199f2_Gemini%20SS26%206.png`,
  ss26_6b: `${A}ng4m6rus_Gemini%20SS26%206%281%29.png`,
  ss26_7:  `${A}78n4jy02_Gemini%20SS26%207%281%29.webp`,
  ss26_8:  `${A}fmkls9lj_Gemini%20SS26%208%281%29.webp`,
  ss26_9:  `${A}zrac6vu6_Gemini%20SS26%209%281%29.webp`,
  ss32_1: `${A}sohjvoio_Gemini%20SS32%201%281%29.webp`,
  ss32_2: `${A}c8k3kida_Gemini%20SS32%202%281%29.png`,
  ss32_3: `${A}kjehjdin_Gemini%20SS32%203%281%29.png`,
  ss32_4: `${A}wxl645er_Gemini%20SS32%204%281%29.webp`,
  ss32_5: `${A}55ne26xl_Gemini%20SS32%205%281%29.webp`,
  ss32_6: `${A}mgh2pqrr_Gemini%20SS32%206%281%29.webp`,
  ss32_7: `${A}rbalsnf4_Gemini%20SS32%207%281%29.webp`,
  ss32_8: `${A}ksepi7iy_Gemini%20SS32%208%281%29.webp`,
  ss32_9: `${A}7lun47nr_Gemini%20SS32%209.webp`,
  ss35_1: `${A}sk989pgq_Gemini%20SS35%201%281%29.webp`,
  ss35_2: `${A}ltjvie45_Gemini%20SS35%202%281%29.png`,
  ss35_3: `${A}f8xbyl9y_Gemini%20SS35%203%281%29.png`,
  ss35_4: `${A}rc6k31cx_Gemini%20SS35%204%281%29.png`,
};

// ---------- Applications ----------
export const APPLICATIONS = [
  { id: 'luxury-resorts',   category: 'hospitality', title: 'Luxury Resorts',    caption: 'Elevate guest experiences with exclusive, nature-connected stays.',           image: `${A}bj1t532j_7a3802eb-240d-4805-84f7-02afd394f8b4.jpeg` },
  { id: 'boutique-hotels',  category: 'hospitality', title: 'Boutique Hotels',   caption: 'Add premium, design-led rooms in less time.',                                  image: `${A}fmtd5w5q_1c535e0f-fb8c-47af-a35e-86c3da8211b5%281%29.jpg.webp` },
  { id: 'glamping',         category: 'hospitality', title: 'Glamping',          caption: 'Create unforgettable stays in the heart of nature.',                           image: `${A}dhl04qst_1fc3c840-54ce-48dd-b7d8-eef67e0c293b.webp` },
  { id: 'rentals',          category: 'hospitality', title: 'Airbnb & Rentals',  caption: 'High-demand stays guests love and remember.',                                  image: IMG.cs33_2 },
  { id: 'weekend-homes',    category: 'residential', title: 'Weekend Homes',     caption: 'Your private escape, whenever you need it.',                                   image: `${A}bkjfcocv_cf58f2ac-8c8b-4ec0-82d4-c9cf1037e07c.webp` },
  { id: 'farmhouses',       category: 'residential', title: 'Farmhouses',        caption: 'Blend modern comfort with rustic surroundings.',                               image: `${A}tt36y7gb_187b7f7d-6369-4a1a-be6b-866302e67fa7.webp` },
  { id: 'retail-popups',    category: 'commercial',  title: 'Retail & Pop-up Stores', caption: 'Stylish, portable spaces that stand out.',                                image: `${A}hu8mxx2l_6170520e-a313-40f9-82b4-38b80ee67430.webp` },
  { id: 'office-spaces',    category: 'commercial',  title: 'Office Spaces',     caption: 'Smart, quiet and productive work environments.',                               image: `${A}iyrgac5o_24b62d0e-c0fd-4a5c-9cca-19debe634c51.webp` },
];

// ---------- Product Families ----------
export const FAMILIES = {
  capsule: {
    id: 'capsule',
    name: 'Capsule Suites',
    tagline: 'Futuristic. Immersive. Iconic.',
    description: 'Capsule Suites feature sculpted forms, panoramic glazing and seamless curves that turn a space into a destination. A signature range of luxury modular homes and modular resort rooms designed to be seen, and remembered.',
    heroImage: IMG.cs33_3,
    image:     IMG.cs33_3,
  },
  studio: {
    id: 'studio',
    name: 'Studio Suites',
    tagline: 'Clean. Versatile. Timeless.',
    description: 'Studio Suites bring clean geometry, refined proportions and understated elegance to modular hospitality, residential and workspace projects. Prefabricated homes and modular offices engineered as complete architectural products.',
    heroImage: IMG.ss26_2,
    image:     IMG.ss26_2,
  },
};

// ---------- Shared feature sets ----------
const capsuleFeatures = ['Futuristic Design', 'Panoramic Views', 'Smart Ready', 'Premium Finishes', 'Compact Footprint', 'Factory Built'];
const studioFeatures  = ['Modern Design', 'Spacious Layout', 'Smart Ready', 'Premium Finishes', 'Compact Footprint', 'Factory Built'];

// ---------- Products (7 models) ----------
export const PRODUCTS = [
  {
    slug: 'cs25', family: 'capsule', name: 'CS25', tagline: 'Compact in size. Unlimited in experience.',
    overview: 'CS25 is a compact luxury capsule home designed for private retreats and boutique resorts. It brings signature Capsule architecture, panoramic glazing and hospitality-grade finishes into a footprint suited to intimate settings.',
    specs: { length: '8.06 m', width: '3.05 m', height: '2.94 m', carpetArea: '25 sq m' },
    features: capsuleFeatures,
    hero: IMG.cs25_1,
    gallery: [IMG.cs25_2, IMG.cs25_4, IMG.cs25_6, IMG.cs25_5],
  },
  {
    slug: 'cs31', family: 'capsule', name: 'CS31', tagline: 'A signature suite for waterfront stays.',
    overview: 'CS31 extends the Capsule silhouette with a longer footprint, offering an ideal signature suite for boutique resorts, waterfront developments and premium short-stay rentals.',
    specs: { length: '10.184 m', width: '3.05 m', height: '2.94 m', carpetArea: '31 sq m' },
    features: capsuleFeatures,
    hero: IMG.cs31_hero,
    gallery: [IMG.cs31_7, IMG.cs31_2, IMG.cs31_3, IMG.cs31_6],
  },
  {
    slug: 'cs33', family: 'capsule', name: 'CS33', tagline: 'Iconic form. Generous interior.',
    overview: 'CS33 balances iconic form with a more generous interior, hosting extended stays without compromising the Capsule silhouette. A flagship modular resort room for cliffside, forest and vineyard projects.',
    specs: { length: '10.710 m', width: '3.05 m', height: '2.94 m', carpetArea: '33 sq m' },
    features: capsuleFeatures,
    hero: IMG.cs33_hero,
    gallery: [IMG.cs33_2, IMG.cs33_3, IMG.cs33_1, IMG.cs33_4, IMG.cs33_9, IMG.cs33_5, IMG.cs33_8],
  },
  {
    slug: 'cs37', family: 'capsule', name: 'CS37', tagline: 'Your next living experience begins here.',
    overview: 'CS37 is our most spacious Capsule Suite. Pairing iconic architecture with a generous open-plan interior, it is purpose-built for luxury resorts, vineyards, mountain retreats and premium residences.',
    specs: { length: '12.07 m', width: '3.05 m', height: '2.94 m', carpetArea: '37 sq m' },
    features: capsuleFeatures,
    hero: IMG.cs37_3,
    gallery: [IMG.cs37_4, IMG.cs37_2, IMG.cs37_1, IMG.cs37_5],
  },
  {
    slug: 'ss26', family: 'studio', name: 'SS26', tagline: 'Smart. Professional. Built for business.',
    overview: 'SS26 is a smart modular office designed for modern businesses. Private cabin, client meeting room or project studio, it delivers comfort, functionality and style in a compact footprint.',
    specs: { length: '8.58 m', width: '3.05 m', height: '2.94 m', carpetArea: '26 sq m' },
    features: ['Professional Design', 'Natural Light', 'Quick Install', 'Premium Finishes', 'Compact Footprint', 'Flexible Use'],
    hero: IMG.ss26_1,
    gallery: [IMG.ss26_2, IMG.ss26_3, IMG.ss26_4, IMG.ss26_5, IMG.ss26_6, IMG.ss26_9, IMG.ss26_7, IMG.ss26_8, IMG.ss26_6b],
  },
  {
    slug: 'ss32', family: 'studio', name: 'SS32', tagline: 'Spacious. Smart. Designed for modern living.',
    overview: 'SS32 offers the perfect balance of privacy and openness. With two separate rooms and a central bathroom, it is ideal for couples, small families or multi-purpose modular homes.',
    specs: { length: '10.28 m', width: '3.05 m', height: '2.94 m', carpetArea: '32 sq m' },
    features: studioFeatures,
    hero: IMG.ss32_1,
    gallery: [IMG.ss32_2, IMG.ss32_3, IMG.ss32_4, IMG.ss32_5, IMG.ss32_6, IMG.ss32_9, IMG.ss32_7, IMG.ss32_8],
  },
  {
    slug: 'ss35', family: 'studio', name: 'SS35', tagline: 'A premium studio for modern getaways.',
    overview: 'SS35 is our premium Studio Suite. A generous open-plan layout with a private sleeping area and a modern bathroom, ideal for luxury getaways, guest houses and long-term rentals.',
    specs: { length: '11.47 m', width: '3.05 m', height: '2.94 m', carpetArea: '35 sq m' },
    features: studioFeatures,
    hero: IMG.ss35_1,
    gallery: [IMG.ss35_4, IMG.ss35_3, IMG.ss35_2],
  },
];

// ---------- Site copy: Why / Technology / Process ----------
export const WHY = [
  { title: 'Factory Built', body: 'Every MODULAROOM is manufactured in a controlled facility where every millimetre is engineered for consistency and quality.' },
  { title: 'Precision Engineered', body: 'Automotive-grade tolerances meet architectural intent. Delivered as a finished product, not assembled on-site.' },
  { title: 'Premium Materials', body: 'From structural steel to architectural glass and designer finishes, every component is selected for durability and aesthetics.' },
  { title: 'Rapid Installation', body: 'Ready in days, not months. Utility connections are all that stand between arrival and move-in.' },
  { title: 'Smart Ready', body: 'Lighting, climate, security and future smart-home technologies are integrated by design.' },
  { title: 'Sustainable', body: 'Off-site construction minimises material waste and improves resource efficiency compared to conventional construction.' },
  { title: 'Turnkey Delivery', body: 'One integrated process: design, manufacture, transport, installation. Delivered worldwide.' },
];

export const TECHNOLOGY = [
  { title: 'Steel Structure', body: 'Corrosion-resistant structural frame engineered for long-term performance.' },
  { title: 'PU Insulation', body: 'High-performance polyurethane insulation maintains indoor comfort year-round.' },
  { title: 'Double Glazing', body: 'Floor-to-ceiling insulated glazing maximises natural light while enhancing thermal and acoustic performance.' },
  { title: 'Aluminium Shell', body: 'Precision aluminium cladding finished with premium 2K automotive paint for exceptional durability.' },
  { title: 'SPC Flooring', body: 'Wood-inspired waterproof flooring designed for durability and effortless maintenance.' },
  { title: 'Climate Control', body: 'Integrated ducted air-conditioning with engineered air circulation for year-round comfort.' },
  { title: 'Waterproof Build', body: 'Fully waterproof exterior with seamless sealing for protection in all environments.' },
  { title: 'Smart Access', body: 'Digital smart lock at the main entrance for secure, keyless entry.' },
];

export const PROCESS = [
  { step: '01', title: 'Factory Manufacturing', body: 'Precision built in a controlled environment with rigorous quality standards.' },
  { step: '02', title: 'Transportation', body: 'Safely transported to your location with secure packaging.' },
  { step: '03', title: 'Placement', body: 'Carefully placed and levelled on prepared foundations.' },
  { step: '04', title: 'Utility Connections', body: 'Simple connections for power, water and drainage.' },
  { step: '05', title: 'Move In', body: 'Fully ready to enjoy your MODULAROOM from day one.' },
];

// ---------- Contact ----------
// Single source of truth for the MODULAROOM office location.
// Verified against the official Google Business listing at https://maps.app.goo.gl/AFxfe7kTu4UXc5hQ8
// (Google Place ID 0x3959cb35a710c389:0x6ad86be61eab2f98 · Plus code 7QJH+QV Rajkot).
export const CONTACT = {
  address: [
    '104, Jay Jaliyan Complex – B',
    'Karan Park Street 1, Main Road',
    'Near Astron Society, Vidhut Nagar',
    'Rajkot – 360001, Gujarat, India',
  ],
  addressLine: '104, Jay Jaliyan Complex – B, Karan Park Street 1, Main Road, near Astron Society, Vidhut Nagar, Rajkot, Gujarat 360001, India',
  geo: { lat: 22.2818806, lng: 70.7796964 },
  plusCode: '7QJH+QV Rajkot',
  phone: '+91 98750 67172',
  email: 'modularoom.info@gmail.com',
  website: 'www.modularoom.com',
  socials: {
    instagram: 'https://instagram.com/modularoom',
    linkedin:  'https://linkedin.com/company/modularoom',
    facebook:  'https://facebook.com/modularoomindia',
    youtube:   'https://www.youtube.com/@modularoom',
  },
  // Google-issued short link — canonical directions URL used across the site.
  mapLink: 'https://maps.app.goo.gl/AFxfe7kTu4UXc5hQ8',
  // Embedded iframe pointing at the exact business location (coord-pinned + labelled).
  mapEmbed: 'https://www.google.com/maps?q=MODULAROOM%20Rajkot%2C%20104%20Jay%20Jaliyan%20Complex%20B%2C%20Karan%20Park%20Street%201%2C%20Vidhut%20Nagar%2C%20Rajkot%20Gujarat%20360001&ll=22.2818806%2C70.7796964&z=17&output=embed',
};

// exposed for concierge image bank (kept named for interop)
export const HERO_HOME = IMG.cs37_3;

// Atmospheric background images for editorial text sections.
// Kept low-opacity by consuming components — luxury restraint.
export const ATMOSPHERE = {
  brandLight:   IMG.cs37_5,     // warm CS37 kitchen interior — for light "brand philosophy" sections
  brandDark:    IMG.cs37_3,     // CS37 vineyard sunrise — for dark CTA blocks
  aboutHeadline:IMG.cs33_3,     // CS33 cliff panoramic sunset — About headline
  aboutValues:  IMG.ss35_3,     // SS35 warm sunset interior — About values
  contactWarm:  IMG.ss35_3,     // SS35 warm sunset interior — Contact hero
  technology:   IMG.ss26_8,     // SS26 aluminium shell close-up — Technology intro
};
